import { AdministrativeArea, Country } from "../../common/redux/countryActions";
import { SubscriptionPlan } from "../../common/redux/subscriptionActions";
import { Profession } from "../../common/redux/professionAction";
import { UserProfessionnelResponse } from "./ProjectModel";

export interface UserStructureResponse {
    societe: string;
    siret: string;
    disponibilities: DisponibiliteStructure[];
    id: string;
    email: string;
    departements: string[];
    roles: string[];
    enabled: boolean;
    ville: string;
    profession: Profession;
    telephone: string;
    profileImage: AvatarResponse;
    description: string;
    country: Country;
    changeRequested?: boolean;
    subscription?: {
        active: boolean;
        subscriptionPlan: SubscriptionPlan;
    };
}

export interface CreateDisponibiliteStructure {
    country: string | null;
    administrativeArea: string | null;
    ville: string | null;
    profession: string | null;
    selection: string[];
    description?: string;
    type: string;
    dateDemarrage: string | null;
    dateFin?: string | null;
    heureDemarrage: string | null;
    heureFin: string | null;
}

export interface DisponibiliteStructure {
    account: UserStructureResponse;
    country: Country;
    administrativeArea: AdministrativeArea;
    ville: string;
    profession: Profession;
    id: string;
    siret: string;
    email: string;
    societe: string;
    departements: string[];
    disponibilities: DisponibiliteStructure[];
    mois: string[];
    selection: string[];
    description: string;
    type: string;
    dateDemarrage: string;
    dateFin: string;
    heureDemarrage: string;
    roles: string[];
    telephone: string;
    profileImage: { contentUrl: string; id: string };
    heureFin: string;
    enabled: boolean;
    interested: ProfessionnelInterestedByStructure[] | null;
    isInterested: {
        status: string;
    };
    profilImageUrl?: string;
    indexOfDisponibility?: number;
    fulfilled?: boolean;
}

export interface ProfessionnelInterestedByStructure {
    id: string;
    Professionnel: UserProfessionnelResponse;
    status: string;
}

export const emptyUserStructure: UserStructureResponse = {
    societe: "",
    siret: "",
    disponibilities: [],
    departements: [""],
    id: "",
    ville: "",
    profession: { id: 0, name: "" },
    email: "",
    roles: [""],
    enabled: false,
    country: { id: 0, name: "", code: "", administrativeAreaName: "" },
    telephone: "",
    profileImage: { contentUrl: "", id: "" },
    description: "",
};

export interface AvatarResponse {
    id: string;
    contentUrl: string;
}
